<template>
  <textarea
    class="nw"
    :value="config.text || ''"
    :placeholder="$t('dashboardWidgets.note.placeholder')"
    maxlength="4000"
    @input="onInput"
    @blur="flush"
    @mousedown.stop
    @touchstart.stop
  ></textarea>
</template>

<script>
/** Nota personal: el texto se guarda con el layout del usuario. */
export default {
  name: "NoteWidget",
  props: {
    entry: { type: Object, required: true },
    config: { type: Object, default: () => ({}) },
  },
  mounted() {
    this.$emit("menu", []);
  },
  methods: {
    onInput(e) {
      clearTimeout(this.timer);
      this.pending = e.target.value;
      this.timer = setTimeout(this.flush, 600);
    },
    flush() {
      clearTimeout(this.timer);
      if (this.pending === undefined) return;
      const text = this.pending;
      this.pending = undefined;
      this.$emit("update-config", { text });
    },
  },
  beforeDestroy() {
    this.flush();
  },
};
</script>

<style scoped>
.nw {
  width: 100%;
  height: 100%;
  min-height: 120px;
  resize: none;
  border: 1px solid var(--dw-note-border);
  border-radius: 8px;
  padding: 10px 12px;
  background: var(--dw-note-bg);
  color: var(--dw-text);
  font-size: 0.9rem;
  line-height: 1.45;
  outline: none;
}
.nw:focus { border-color: var(--bs-warning); }
</style>
